import React from 'react'
import PropTypes from 'prop-types'
import { DefaultError } from './default-error'

class ChartErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console or error reporting service
    console.error('Chart Error Boundary caught an error:', error, errorInfo)
    
    // You can also log the error to an error reporting service here
    // For example: logErrorToService(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      // Render fallback UI
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
          <DefaultError />
        </div>
      )
    }

    return this.props.children
  }
}

ChartErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
}

export default ChartErrorBoundary